module.exports = "https://media.zlongame.com/media/pictures/cn/vipCenter/assets/img/appkeyIcon/icon_1656417299063.png";